import { render, staticRenderFns } from "./FormImageDragSelector.vue?vue&type=template&id=5f7be45a&"
import script from "./FormImageDragSelector.vue?vue&type=script&lang=ts&"
export * from "./FormImageDragSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports